<div class="chart-pie-variable">
  <highcharts-chart
      [Highcharts]="hc"
      [options]="chartOptions"
      (chartInstance)="chartInit($event)"
      [style.display]="'block'"
      [style.width.%]="100"
  ></highcharts-chart>
</div>
